import { render, staticRenderFns } from "./ListarMarcas.vue?vue&type=template&id=9d3dd5a8&"
import script from "./ListarMarcas.vue?vue&type=script&lang=js&"
export * from "./ListarMarcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports